import { ThemeOverride } from '@abstractTypes/theme'
import { fonts } from '@theme/index'

export const dcTheme: ThemeOverride = {
  colors: {
    primaryDark: '#00303C',
    primaryDarkPressed: '#014758',
    primaryLight: '#FFFFFF',
    primaryLightPressed: '#FFFFFF',
    inactive: '#AFAFAF',
    outline: '#D8D8D8',
    background: '#F6F6F6',
    highlight01: '#00303C',
    highlight01Pressed: '#014758',
    highlight02: '#83C8BB',
    highlight02Pressed: '#BCE7DF',
    highlight03: '#00303C',
    highlight04: '#196576',
    functional01: '#D32113',
    functional02: '#247534',
    functional03: '#F0A63C',
  },
  fonts: {
    ...fonts,
    heading0: {
      fontFamily: 'Montserrat',
      weight: {
        regular: 400,
      },
      fontSize: {
        tower: 85,
        tablet: 68,
        tabletMini: 60,
      },
      lineHeight: {
        tower: 109,
        tablet: 86,
        tabletMini: 67,
      },
    },
    heading1: {
      fontFamily: 'Montserrat',
      weight: {
        regular: 400,
      },
      fontSize: {
        tower: 60,
        tablet: 56,
        tabletMini: 48,
      },
      lineHeight: {
        tower: 68,
        tablet: 62,
        tabletMini: 60,
      },
    },
    heading2: {
      fontFamily: 'Montserrat',
      weight: {
        regular: 400,
      },
      fontSize: {
        tower: 40,
        tablet: 40,
        tabletMini: 34,
      },
      lineHeight: {
        tower: 48,
        tablet: 48,
        tabletMini: 46,
      },
    },
    heading3: {
      fontFamily: 'Montserrat',
      weight: {
        regular: 400,
      },
      fontSize: {
        tower: 34,
        tablet: 34,
        tabletMini: 28,
      },
      lineHeight: {
        tower: 44,
        tablet: 44,
        tabletMini: 36,
      },
    },
    heading4: {
      fontFamily: 'Montserrat',
      weight: {
        regular: 400,
        bold: 700,
      },
      fontSize: {
        tower: 24,
        tablet: 24,
        tabletMini: 20,
      },
      lineHeight: {
        tower: 36,
        tablet: 36,
        tabletMini: 30,
      },
    },
    heading5: {
      fontFamily: 'Montserrat',
      weight: {
        regular: 400,
        bold: 600,
      },
      fontSize: {
        tower: 20,
        tablet: 20,
        tabletMini: 18,
      },
      lineHeight: {
        tower: 26,
        tablet: 26,
        tabletMini: 28,
      },
    },
    body: {
      fontFamily: 'Montserrat',
      weight: {
        regular: 400,
        bold: 600,
      },
      fontSize: {
        tower: 18,
        tablet: 16,
        tabletMini: 16,
      },
      lineHeight: {
        tower: 26,
        tablet: 24,
        tabletMini: 24,
      },
    },
    label: {
      fontFamily: 'Montserrat',
      weight: {
        regular: 400,
      },
      fontSize: {
        tower: 14,
        tablet: 14,
        tabletMini: 12,
      },
      lineHeight: {
        tower: 24,
        tablet: 24,
        tabletMini: 18,
      },
    },
    cta: {
      fontFamily: 'Montserrat',
      weight: {
        regular: 500,
        bold: 600,
      },
      fontSize: {
        tower: 18,
        tablet: 16,
        tabletMini: 16,
      },
      lineHeight: {
        tower: 26,
        tablet: 24,
        tabletMini: 26,
      },
    },
    link: {
      fontFamily: 'Montserrat',
      weight: {
        regular: 400,
      },
      fontSize: {
        tower: 24,
        tablet: 24,
        tabletMini: 20,
      },
      lineHeight: {
        tower: 30,
        tablet: 30,
        tabletMini: 26,
      },
    },
    caption: {
      fontFamily: 'Montserrat',
      weight: {
        regular: 600,
      },
      fontSize: {
        tower: 13,
        tablet: 13,
        tabletMini: 11,
      },
      lineHeight: {
        tower: 16,
        tablet: 16,
        tabletMini: 14,
      },
    },
  },
  components: {
    button: {
      style: 'squared',
      uppercase: true,
    },
    rangeSlider: {
      background: '#AFAFAF', //inactive
      foreground: '#00303C', //highlight01
      thumb: '#F6F6F6', //background
      thumbBorder: '#AFAFAF', //inactive
    },
  },
}
